import { render, staticRenderFns } from "./ProductMaster.vue?vue&type=template&id=9964408c&scoped=true&"
import script from "./ProductMaster.vue?vue&type=script&lang=js&"
export * from "./ProductMaster.vue?vue&type=script&lang=js&"
import style0 from "./ProductMaster.vue?vue&type=style&index=0&id=9964408c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9964408c",
  null
  
)

export default component.exports